export const NAV_STORAGE_KEYS = {
  wantOnlyBarrierFreePaths: 'wantOnlyBarrierFreePaths',
  showVirtualKeyboard: 'showVirtualKeyboard',
  currentUri: 'currentURI',
};
